import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RideHistoryService {

    constructor(@Inject('ENV') private env: any, private http: HttpClient, private datePipe: DatePipe) {}

    fetchPurchaseHistory(startDate: Date, endDate: Date, token = null): Observable<any> {
        const start = this.datePipe.transform(startDate, 'yyyy-MM-dd');
        const end = this.datePipe.transform(endDate, 'yyyy-MM-dd');
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/ondemand/order/history/start-date/${start}/end-date/${end}`;

        let headers = new HttpHeaders();
        headers = headers.set('Authorization', `Bearer ${token}`);

        return this.http.get(url, { headers });
    }
}
